import { render } from "./BusinessRuleActions.vue?vue&type=template&id=7dbfe8f8"
import script from "./BusinessRuleActions.vue?vue&type=script&lang=js"
export * from "./BusinessRuleActions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__